import { Component, OnInit, EventEmitter  } from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter } from 'rxjs/operators';
declare let $: any;
import { HostListener } from '@angular/core';

import { ISlimScrollOptions, SlimScrollEvent } from 'ngx-slimscroll';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ],
})

export class AppComponent implements OnInit {
  opts: ISlimScrollOptions;
  scrollEvents: EventEmitter<SlimScrollEvent>;
  
  location: any;
  routerSubscription: any;

  constructor(private router: Router) {
  }

  ngOnInit(){
	  this.recallJsFuntions();
  }
	@HostListener('window:beforeunload', ['$event'])
	beforeunloadHandler($event) {
		var reloadFrom = localStorage.getItem('reloadFrom');
		if (reloadFrom==="location") {
			localStorage.removeItem('reloadFrom');

		} else {
			localStorage.removeItem('isOrderDateTimeChange');
			localStorage.removeItem('orderDatetime');
			localStorage.removeItem('orderDate');
		}
		localStorage.removeItem('url_store_id');

	}
  recallJsFuntions() {
      this.router.events
      .subscribe((event) => {
          if ( event instanceof NavigationStart ) {
              $('.ct-preloader').fadeIn('slow');
          }
      });
      this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
      .subscribe(event => {
          $.getScript('assets/js/main.js');
          $('.ct-preloader').fadeOut('slow');
          this.location = this.router.url;
          if (!(event instanceof NavigationEnd)) {
              return;
          }
          window.scrollTo(0, 0);
      });
  }
}
